module.exports = __webpack_public_path__ + "static/media/Icons.f4ad0c14.xd";